import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const deleteComment = async (id: string) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.contentObjects.comment.delete(id));
